import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export async function ensureClubBootstrap(clubId: string) {
  const fn = httpsCallable(functions, "ensureClubBootstrap");
  return (await fn({ clubId })).data as { clubCreated: boolean; configCreated: boolean };
}
